import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useFetchBrandAmbassadors = (queryParams) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("brand-ambassadors", {
			params: { ...params },
		});
		return res.data;
	};

	// const enabled = Boolean(queryParams?.enabled);

	return useQuery(["users", "brand_ambassador", queryParams], () => fetch(), {
		...fetchConfig,
		// enabled: enabled,
	});
};

export default useFetchBrandAmbassadors;
